import { render, staticRenderFns } from "./MaterialExamSubject.vue?vue&type=template&id=050361a0&scoped=true&"
import script from "./MaterialExamSubject.vue?vue&type=script&lang=js&"
export * from "./MaterialExamSubject.vue?vue&type=script&lang=js&"
import style0 from "./MaterialExamSubject.vue?vue&type=style&index=0&id=050361a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050361a0",
  null
  
)

export default component.exports